export const PLY_CHANNEL_NAME = 'ply';
export const BROADCAST_CHANNEL = 'fromBroadcastChannel';

export enum EVENTS {
	LOGIN = 'login',
	LOGOUT = 'logout',
	SET_USER = 'setUser',
}

export type EVENT = keyof typeof EVENTS;
